import React from "react";
import { ArrowRight, ClipboardList } from "lucide-react";
import { Button } from "../../components/Button";
import { PublicFooter, PublicHeader } from "../../components/PublicChrome";
import { View } from "../../types/system";
const cards = [{
  title: "জাতীয় পর্যটন আলোকচিত্র প্রতিযোগিতা ২০২৬",
  type: "ছবি প্রতিযোগিতা",
  deadline: "১৫ অক্টোবর ২০২৬"
}, {
  title: "বাংলাদেশ ট্যুরিজম অ্যাওয়ার্ড ২০২৬",
  type: "অ্যাওয়ার্ড",
  deadline: "৩০ অক্টোবর ২০২৬"
}, {
  title: "Taste of Bangladesh ২০২৬",
  type: "ফেস্টিভ্যাল",
  deadline: "১২ অক্টোবর ২০২৬"
}, {
  title: "ITB Berlin ২০২৭",
  type: "আন্তর্জাতিক পর্যটন মেলা",
  deadline: "২০ নভেম্বর ২০২৬"
}];
export function ApplicantHome({
  onNavigate
}: {
  onNavigate: (v: View) => void;
}) {
  return <div className="min-h-screen bg-[#F7F9F8]" data-id="element-1505" data-mp="3luyh2ywk5ofx">
      <PublicHeader onNavigate={onNavigate} data-id="element-1506" data-mp="4ljlezm5gtox" />
      <section className="bg-[#005A3C] text-white" data-id="element-1507" data-mp="4mkuiyjlv640">
        <div className="mx-auto max-w-6xl px-4 py-14 md:px-6" data-id="element-1508" data-mp="3vsw4jk6lfh7h">
          <p className="text-xs font-medium text-white/70" data-id="element-1509" data-mp="3vq9n8stwhnc2">গণপ্রজাতন্ত্রী বাংলাদেশ সরকার · বেসামরিক বিমান পরিবহন ও পর্যটন মন্ত্রণালয়</p>
          <h1 className="mt-3 max-w-2xl text-3xl font-bold leading-snug md:text-4xl" data-id="element-1510" data-mp="pcoxzpiwg0xh">বাংলাদেশ ট্যুরিজম বোর্ডের চলমান ইভেন্ট ও আবেদন</h1>
          <p className="mt-3 max-w-xl text-white/80" data-id="element-1511" data-mp="td8t6njwwugz">প্রতিযোগিতা, অ্যাওয়ার্ড, উৎসব, পর্যটন মেলা এবং অন্যান্য কর্মসূচিতে অনলাইনে আবেদন করুন।</p>
          <p className="mt-4 max-w-xl text-sm text-white/70" data-id="element-1512" data-mp="13cznop8h39h2">বাংলাদেশের পর্যটন উন্নয়ন, প্রচার ও অংশীজন সম্পৃক্ততার জন্য অনলাইন আবেদন ও প্রতিযোগিতা ব্যবস্থাপনা প্ল্যাটফর্ম।</p>
          <div className="mt-7 flex flex-wrap gap-3" data-id="element-1513" data-mp="189yhf6o85eeq">
            <Button className="h-11 bg-white px-5 text-[#005A3C] hover:bg-white/90" data-id="element-1514" data-mp="1d2jau737xphq">চলমান আবেদন দেখুন<ArrowRight className="ml-1.5 h-4 w-4" data-id="element-1515" data-mp="1h4wg6ue1zldz" /></Button>
            <Button onClick={() => onNavigate("applicant-dashboard")} variant="outline" className="h-11 border-white/40 bg-transparent px-5 text-white hover:bg-white/10" data-id="element-1516" data-mp="1h67gulc7cd0v"><ClipboardList className="mr-1.5 h-4 w-4" data-id="element-1517" data-mp="1r3lte9v08hnw" />আমার আবেদন দেখুন</Button>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-10 md:px-6" data-id="element-1518" data-mp="3n5yp8eoip07n">
        <h2 className="mb-5 text-xl font-bold text-[#1F2937]" data-id="element-1519" data-mp="3i7nhc9hs8zs2">চলমান ইভেন্ট ও প্রতিযোগিতা</h2>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1520" data-mp="qdy892voqhc">
          {cards.map(c => <article key={c.title} className="flex flex-col rounded-xl border border-[#D9E2DE] bg-white p-5 shadow-sm" data-id="element-1521" data-mp="3s3qqw0eys0p1">
              <span className="mb-3 inline-block w-fit rounded-full bg-[#EAF5F1] px-2.5 py-1 text-[11px] font-medium text-[#006A4E]" data-id="element-1522" data-mp="9ozfm0wm5zgj">{c.type}</span>
              <h3 className="flex-1 font-bold leading-snug text-[#1F2937]" data-id="element-1523" data-mp="jpi7niyc0m9j">{c.title}</h3>
              <p className="mt-3 text-xs text-[#667085]" data-id="element-1524" data-mp="eq59i220fsrn">আবেদনের শেষ তারিখ: <span className="font-medium text-[#C61E35]" data-id="element-1525" data-mp="eqortjvkoj67">{c.deadline}</span></p>
              <div className="mt-4 flex gap-2" data-id="element-1526" data-mp="2lh4s11npxix1">
                <Button onClick={() => onNavigate("event-detail")} size="sm" variant="outline" className="flex-1" data-id="element-1527" data-mp="2gh8n90775ngf">বিস্তারিত</Button>
                <Button onClick={() => onNavigate("event-detail")} size="sm" className="flex-1 bg-[#006A4E] text-white hover:bg-[#005A3C]" data-id="element-1528" data-mp="vyy61d59i7hd">আবেদন করুন</Button>
              </div>
            </article>)}
        </div>
      </section>
      <PublicFooter data-id="element-1529" data-mp="m94to9xapoc2" />
    </div>;
}